import Alert from 'components/atoms/Alert/Alert';
import LocaleAwareImage from 'components/atoms/LocaleAwareImage/LocaleAwareImage';
import RegistrationCard from 'components/atoms/RegistrationCard/RegistrationCard';
import SecondFactorCode from 'components/atoms/TextInput/SecondFactorCode';
import Txt from 'components/atoms/Txt/Txt';
import Form from 'components/molecules/Form/Form';
import { useConfirm2fa } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { StepProps } from './RegistrationForm';
import classes from './RegistrationForm.module.scss';

export default function SecondFactorStep({ onNext, menu, error, sessionId }: StepProps) {
  const confirm2fa = useConfirm2fa();
  const router = useRouter();
  const [localError, setLocalError] = useState<string | null>(null);

  function handleSubmit(formData: FormData) {
    if (formData.has('2fa_code') && sessionId) {
      confirm2fa(sessionId, formData.get('2fa_code')?.toString() ?? '')
        .then((result) => {
          router.push('/dashboard');
        })
        .catch((e) => {
          if (e instanceof Error) {
            setLocalError(e.message);
          } else {
            setLocalError('An error occurred');
          }
        });
    }
  }

  return (
    <RegistrationCard
      title="Two factor authentication required"
      menu={menu}
      additionalInfo={{
        title: 'Surveys tailored to you',
        subtitle: (
          <>
            <Txt component={'p'}>
              Once you sign up, answer a few questions about yourself and start receiving surveys
              that match your interests. The more time you spend with LifePoints, the bigger the
              rewards.
            </Txt>
            <Txt component={'p'}>Start earning today!</Txt>
          </>
        ),
        image: (
          <LocaleAwareImage
            alt=""
            src="/assets/registration-password.png"
            width={431}
            height={234}
          />
        ),
      }}
    >
      {error}
      {localError && (
        <Alert
          type={'error'}
          title={'An error occurred'}
          subtitle={localError}
          onClose={() => setLocalError(null)}
        />
      )}
      <Txt component={'p'}>
        We&apos;ve sent a code to your primary contact method, please enter the code below.
      </Txt>
      <Form
        submitName="Sign Up"
        submitButtonType="primary"
        submitButtonClassName={classes.nextButton}
        onSubmit={handleSubmit}
        className={classes.formOverrides}
      >
        <SecondFactorCode />
      </Form>
    </RegistrationCard>
  );
}
